import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import type { CountryRes } from 'api/swagger';
import { CLIENT_APP_COUNTRIES } from 'client-app/api/query-keys';

export const useGetCountriesForClientOffice = () => {
  return useQuery<CountryRes[]>({
    queryKey: [CLIENT_APP_COUNTRIES],
    queryFn: async () => {
      const { data } = await http.get<CountryRes[]>(`client-office/v1/countries`);

      return data;
    },
    retry: 2,
    cacheTime: Infinity,
    staleTime: Infinity,
  });
};
